// Central test-id registry for the PromptForge app
export const FORGE = {
    logo: "profecia-logo",
    briefTextarea: "brief-textarea",
    llmSelect: "llm-select",
    brandSelect: "brand-select",
    contentTypeSelect: "content-type-select",
    aspectSelect: "aspect-select",
    runButton: "run-pipeline-button",
    stopButton: "stop-pipeline-button",
    resetButton: "reset-button",
    demoBriefButton: "load-demo-brief-button",
    copyFinalButton: "copy-final-prompt-button",
    finalPromptCard: "final-prompt-card",
    finalPromptText: "final-prompt-text",
    pipelineNode: (id) => `agent-node-${id}`,
    agentCard: (id) => `agent-card-${id}`,
    agentToggle: (id) => `agent-toggle-${id}`,
    agentOutput: (id) => `agent-output-${id}`,
    historySidebar: "history-sidebar",
    historyItem: (id) => `history-item-${id}`,
    newRunButton: "new-run-button",
};
